import styled from 'styled-components';
import { profileLayoutDesktopFrameStyles } from '@/features/Profile/core/ProfileLayout/ProfileLayout.styled';

export const Box = styled.div`
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 0 15px 20px;
    background-color: ${({ theme }) => theme.palette.primary.background};
    border-radius: 0 0 21px 21px;
  }
`;

export const Container = styled.div`
  display: grid;
  gap: 20px;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 30px;
    ${profileLayoutDesktopFrameStyles}
  }
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
  color: ${({ theme }) => theme.palette.primary.labels};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;
  }
`;

export const DesktopOnly = styled.div`
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;
  }
`;

export const MobileOnly = styled.div`
  display: none;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: block;
  }
`;
